import { ViaCepResponseDTO } from "@repo/core/services/entities/Viacep";
import { AxiosInstance, AxiosResponse } from "axios";

export class ViacepResource {
  apiProvider: AxiosInstance;

  constructor(instance: AxiosInstance) {
    this.apiProvider = instance;
  }

  async fetchCep(cep: string): Promise<AxiosResponse<ViaCepResponseDTO>> {
    return this.apiProvider.get(`${cep}/json`);
  }
}
